// @flow
import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

//import Logo from '../../assets/images/logo.png';
// import Logo from '../../assets/images/errands.png';
import Logo from '../../assets/images/logo-hi-res.png';


type AccountLayoutProps = {
  bottomLinks?: React$Element<any>,
  children?: any,
};

const AccountLayout = ({ bottomLinks, children }: AccountLayoutProps): React$Element<any> => {

  useEffect(() => {
    if (document.body) document.body.classList.add('authentication-bg');

    return () => {
      if (document.body) document.body.classList.remove('authentication-bg');
    };
  }, []);

  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
        <Container>
          <Row className="justify-content-between">
            <Col xs={12} md={8} lg={6} xl={5} xxl={4} className='align-center my-auto'>
              <div className='text-center'>
                <img src={Logo} alt="errands-logo" height="270" width="270" />
                <div className='mt-0 text-white text-under-logo text-center'>Errands customer portal</div>
              </div>
            </Col>

            <Col xs={12} md={8} lg={6} xl={5} xxl={4}>
              <Card style={{ borderRadius: '36px' }} >
                {/* <Card.Header className="pt-2 pb-2 text-center" style={{ backgroundColor: '#0047ab' }}>
                                    <Link to="/">
                                        <span>
                                            <img src={Logo} alt="" height="30" />
                                        </span>
                                    </Link>
                                </Card.Header> */}
                <Card.Body className="p-4">
                  {children}
                  {bottomLinks}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div >
      <footer className="footer footer-alt">{`${currentYear} © Errands NYC`}</footer>
    </>
  );
};

export default AccountLayout;
